"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_util_1 = require("@giphy/js-util");
var api_1 = require("./api");
exports.GiphyFetch = api_1.default;
var paginator_1 = require("./paginator");
exports.gifPaginator = paginator_1.gifPaginator;
var version = require('../package.json').version;
// since we have multiple SDKs, we're defining a hieracrchy
// Fetch API is lowest
if (!js_util_1.getGiphySDKRequestParams()["x-giphy-sdk-name"]) {
    // send params with library type and version
    js_util_1.appendGiphySDKRequestParam("x-giphy-sdk-name", 'FetchAPI');
    js_util_1.appendGiphySDKRequestParam("x-giphy-sdk-version", version);
}
//# sourceMappingURL=index.js.map